import 'src/pages/landings/landing_v4/index.js';
import 'src/pages/landings/landing_v4/carousel.js';
import 'src/pages/landings/landing_v4/tabs.js';

import 'styles/views/landings/landing_v4/index.sass';
import 'styles/views/landings/landing_v4/specialist.sass';
import 'src/components/NewsSubscribeLanding/NewsSubscribeLanding.sass';
